import { Box, Typography } from '@mui/material';
import React, { type FC } from 'react';

interface StreamOffMessageProps {
  isPlaying: boolean;
  inactivity: boolean;
}
const StreamOffMessage: FC<StreamOffMessageProps> = ({ isPlaying, inactivity }) => {
  return !isPlaying || inactivity ? (
    <Box
      sx={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        backgroundColor: 'transparent',
        zIndex: 10,
        color: 'white',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <Typography>{`Stream turned off${inactivity ? ' due to inactivity' : ''}`}</Typography>
    </Box>
  ) : null;
};

export default StreamOffMessage;
